import React, { useMemo, memo } from 'react';
import { Chartjs } from '../../../../components';
import { LoadingSpinner } from '../../../../components';
import { getChartTitle, getChartConfig } from './utils';
import { useAppContext } from '../../../../context/AppState.jsx';
import i18n from '../../../../i18n';

function Level1OverviewChart() {
	const [state] = useAppContext();

	const locationTitleText = useMemo(() => getChartTitle(state), [state.setUrlQueryParam, i18n.language]);

	const config = useMemo(() => getChartConfig(state, locationTitleText), [state.setUrlQueryParam, i18n.language]);

	const chartSize = useMemo(
		() => ({
			height: '640px',
			width: '100%',
		}),
		[state.setUrlQueryParam],
	);

	if (!state?.indexedYml) {
		return <LoadingSpinner />;
	}

	return <Chartjs chartConfig={config} chartId="level1OverviewChart" chartSize={chartSize} />;
}

export default memo(Level1OverviewChart);
